import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BreadcrumbService, Breadcrumb } from 'angular-crumbs';
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import { Global } from 'src/services/global.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    Location,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription!: Subscription;

  constructor(
    private global: Global,
    private titleService: Title,
    private breadcrumbService: BreadcrumbService
  ) {
    this.global.init();
  }

  ngOnInit(): void {
    this.subscription = this.breadcrumbService.breadcrumbChanged.subscribe((crumbs) => {
      this.titleService.setTitle(this.createTitle(crumbs));
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  onActivate(_event: any) {
    window.scroll(0, 0);
  }
  private createTitle(routesCollection: Breadcrumb[]) {
    const title = '浙江誉州阀门集团有限公司';
    const titles = routesCollection.filter((route) => route.displayName);
    if (!titles.length) {
      return title;
    }
    const routeTitle = this.titlesToString(titles);
    return `${title}${routeTitle}`;
    // return `${title}${routeTitle};
  }

  private titlesToString(titles: any[]) {
    return titles.reduce((prev, curr) => {
      return `${prev} || ${curr.displayName}`;
    }, '');
  }
}
